function fixHeightCover() {
  // var
  let container = document.getElementById("top-cover");
  let header = document.querySelectorAll(".shopify-section-group-header-group");
  let deviceHeight = window.innerHeight;
  let fixHeight = deviceHeight;
  let minHeight = 500;

  // calc
  header.forEach((element) => {
    fixHeight -= element.offsetHeight;
  });

  // set
  if(container !== null){
    container.style.height = fixHeight > minHeight ? fixHeight + "px" : minHeight + "px";
  }
}

document.addEventListener("DOMContentLoaded", (e) => {
  console.log(e.type);
  fixHeightCover();
});

// window.onload = (e) => {
//   // console.log(e.type);
//   fixHeightCover();
// };

window.onresize = (e) => {
  // console.log(e.type);
  fixHeightCover();
};
